import React from 'react'

import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Typography from '@material-ui/core/Typography'
import { ListItem, ListItemAvatar, ListItemSecondaryAction, IconButton } from '@material-ui/core'
import ProfileImage from '../../components/profile/ProfileImage'

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({})

export const BuddyImage = ({ profile }) => {
  return (
    <ProfileImage size={60} profile={{ profileFilename: _.get('profileImage', profile), ...profile }} />
  )
}

export const BaseBuddy = ({ profile }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <ListItemAvatar>
        <BuddyImage profile={profile} />
      </ListItemAvatar>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
        <Typography style={{ fontSize: 16 }}>
          {_.get('name', profile)}

          {Boolean(_.get('isManagedBy', profile)) && <Typography style={{ display: 'inline', fontSize: 12, color: '#00000080' }}> manages you</Typography>}
        </Typography>
        <Typography style={{ fontWeight: 100, fontSize: 12 }}>{_.get('homeClubName', profile)}</Typography>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          {Boolean(_.get('handicap', profile)) && <Typography style={{ display: 'inline', fontSize: 12, color: '#00000080', paddingRight: 6 }}>{`HCP ${_.get('handicap', profile)}`}</Typography>}
          {Boolean(!_.isEmpty(_.get('orgIds', profile))) && <Typography style={{ display: 'inline', fontSize: 12, color: '#00000080' }}>{_.get('orgIds', profile)}</Typography>}
        </div>
      </div>
    </div>
  )
}

const Buddy = ({ profile, primary, secondary, shouldLink = true }) => {
  const to = React.useMemo(
    () => (`/u/${_.get('handle', profile)}`),
    [profile]
  )

  const renderLink = React.useMemo(
    () => React.forwardRef((itemProps, ref) => <Link to={to} ref={ref} {...itemProps} />),
    [to]
  )

  return (
    <ListItem button onClick={() => !shouldLink && _.result('action', primary)} component={(_.get('handle', profile) && shouldLink) && renderLink}>
      <BaseBuddy profile={profile} />
      <ListItemSecondaryAction style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {(!_.get('disabled', secondary) && !_.isEmpty(secondary)) && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation()
              _.result('action', secondary)
            }}
          >
            {_.get('icon', secondary)}
          </IconButton>
        )}

        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            _.result('action', primary)
          }}
        >
          {_.get('icon', primary)}
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export default _.compose(
  withStyles(styles),
  connect(
    (s, p) => ({}),
    (d, p) => ({})
  )
)(Buddy)
